// ════════════════════════════════════════════════════════════
// TanStack Query client — ECR
// ════════════════════════════════════════════════════════════
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Considère les données fraîches pendant 30s avant de refetch
      staleTime: 30_000,
      // Garde en cache 5 minutes après le dernier composant qui les utilise
      gcTime: 5 * 60_000,
      // Retry policy : 1 retry sauf sur 401/403/404
      retry: (failureCount, error: unknown) => {
        if (failureCount >= 1) return false;
        if (typeof error === 'object' && error !== null && 'status' in error) {
          const status = (error as { status: number }).status;
          if ([401, 403, 404].includes(status)) return false;
        }
        return true;
      },
      refetchOnWindowFocus: import.meta.env.PROD,
    },
    mutations: {
      retry: 0,
    },
  },
});
